module.exports = __webpack_public_path__ + "img/university_verified.bd5a8145.svg";